module.exports = "/_next/static/images/wreath_global_startup_v2-56ab1c26f3cfc9321fa81e780d3e65cd.webp";